import { ref } from '@vue/composition-api';
import { iReview } from '@/entities/review/review.types';

export default function () {
  const reviewInstance = ref<iReview | undefined>(undefined);

  return {
    reviewInstance,
  };
}
